import { styled } from "@mui/material";
import { calendarDayName } from "../classes.js";
const doNotForward = /* @__PURE__ */ new Set(["ownerState", "palette"]);
const Dot = styled("span", {
  name: calendarDayName,
  slot: "Dot",
  overridesResolver: (_, styles) => [styles.dot],
  shouldForwardProp: (prop) => !doNotForward.has(prop)
})(({ theme, palette, ownerState }) => {
  const selection = ownerState?.selection;
  const accentColor = palette?.accentColor ?? (theme.vars ?? theme).palette.primary.main;
  const textColor = palette?.textColor ?? (theme.vars ?? theme).palette.primary.contrastText;
  return {
    left: "50%",
    bottom: 0,
    position: "absolute",
    width: 3,
    height: 3,
    borderRadius: "50%",
    transform: "translate(-50%, -100%)",
    backgroundColor: accentColor,
    ...(selection === "day" || selection === "rangeStart" || selection === "rangeEnd") && {
      backgroundColor: textColor
    }
  };
});
export {
  Dot
};
//# sourceMappingURL=Dot.js.map
